import { MajorCollegeSummary } from './types';

/**
 * Groups majors by their typicalCollege field
 * Returns a Map to preserve insertion order based on provided college order
 *
 * @param majors - Array of majors to group
 * @param collegeOrder - Array of college names defining display order
 */
export const groupMajorsByCollege = (
  majors: MajorCollegeSummary[],
  collegeOrder: string[],
): Map<string, MajorCollegeSummary[]> => {
  const grouped = new Map<string, MajorCollegeSummary[]>();

  // Initialize with empty arrays in the order provided by the API
  collegeOrder.forEach((college) => {
    grouped.set(college, []);
  });

  // Group majors
  majors.forEach((major) => {
    const college = major.typicalCollege;
    const existingMajors = grouped.get(college);

    if (existingMajors) {
      existingMajors.push(major);
    } else {
      // Handle any colleges not in our predefined list
      grouped.set(college, [major]);
    }
  });

  // Sort majors within each college alphabetically
  grouped.forEach((collegeMajors, college) => {
    grouped.set(
      college,
      collegeMajors.sort((a, b) => a.name.localeCompare(b.name)),
    );
  });

  return grouped;
};
